export function optimalNumberOfColumnsFromWidth(width: Nullable<number>, minimumWidth: number) {
  if (width === null) {
    return 1;
  }
  const count = Math.round(width / minimumWidth);
  return Math.min(Math.max(count, 1), 4);
}

export function orderItemVertically<T>(oldIndex: number, value: T, numberOfColumns: number, numberOfRows: number) {
  const y = oldIndex % numberOfRows;
  const x = Math.floor(oldIndex / numberOfRows);
  const newIndex = y * numberOfColumns + x;

  return { value, oldIndex, newIndex, y, x };
}

export function getNumberOfRowsVerticallyOrdered(numberOfItems: number, numberOfColumns: number) {
  return Math.ceil(numberOfItems / numberOfColumns);
}

export function orderVertically<T>(fields: readonly T[], numberOfColumns: number): T[] {
  if (numberOfColumns < 1 || numberOfColumns > 12) {
    throw new Error('invalid number of columns : ' + numberOfColumns);
  }
  const numberOfRows = getNumberOfRowsVerticallyOrdered(fields.length, numberOfColumns);

  return fields
    .map((val, oldIndex) => orderItemVertically<T>(oldIndex, val, numberOfColumns, numberOfRows))
    .sort((a, b) => a.newIndex - b.newIndex)
    .map(x => x.value);
}
